import { useContext, useMemo } from "react";
import {
    routesDefault
} from "../main/routes-role";
import { MeContext } from "../contexts/me-context/me-context";

export const useRouteRole = () => {
    const { role } = useContext(MeContext);

    const routes = useMemo(() => {
        return routesDefault();
    }, [role]);

    return { routes };
};
